import { phone } from 'phone';

/**
 * Formats a phone number for display as +1 (XXX) XXX-XXXX for NANP numbers.
 * Accepts any format (E.164, partial, etc.) and returns a display string.
 * For empty/invalid input, returns the original string or empty string.
 */
export function formatPhoneNumberForDisplay(value: string): string {
  if (!value || !value.trim()) {
    return '';
  }
  const trimmed = value.trim();
  const result = phone(trimmed, { validateMobilePrefix: false });
  if (!result.isValid || !result.phoneNumber) {
    return trimmed;
  }
  if (result.countryCode !== '+1') {
    return result.phoneNumber;
  }
  const digits = normalizePhoneNumber(result.phoneNumber).slice(1);
  if (digits.length !== 10) {
    return result.phoneNumber;
  }
  const area = digits.slice(0, 3);
  const exchange = digits.slice(3, 6);
  const subscriber = digits.slice(6, 10);
  return `+1 (${area}) ${exchange}-${subscriber}`;
}

// Compare on digits only so formatting (spaces, dashes, leading +) never matters.
export const normalizePhoneNumber = (value: string | null | undefined): string =>
  (value ?? '').replace(/\D/g, '');
